import React from "react";
import "../CSS/LifeSciences.css";
import { Box } from "@mui/material";
import lifeSciencesHero from "../Images/solutions/Life Sciences/solution-life-sciences.png";
import lifeSciencesHeroMob from "../Images/Mobile Images/solutions/Life Sciences/solution-life-sciences-banner-image-mobile.png";
import lifeSciencesDivider from "../Images/solutions/Life Sciences/life-sciences-divider-image.png";
import lifeSciencesDividerMob from "../Images/Mobile Images/solutions/Life Sciences/life-sciences-divider-image-mobile.png";
import clinicalDataAbstractionImgMob from "../Images/Mobile Images/solutions/Life Sciences/clinical-data-abstraction-image-mobile.png";
import patientEngagementImgMob from "../Images/Mobile Images/solutions/Life Sciences/patient-engagement-image-mobile.png";
import pharmacovigilanceImgMob from "../Images/Mobile Images/solutions/Life Sciences/pharmacovigilance-image-mobile.png";
import decentralizedTrialsImgMob from "../Images/Mobile Images/solutions/Life Sciences/decentralized-clinical-trials-image-mobile.png";
import lifeScience1 from "../Images/solutions/Life Sciences/LifeScience1.jpg";
import lifeScience2 from "../Images/solutions/Life Sciences/LifeScience2.jpg";
import lifeScience3 from "../Images/solutions/Life Sciences/LifeScience3.png";
import clinicalDataAbstractionImg from "../Images/solutions/Life Sciences/clinical-data-abstraction-image.png";
import { Link } from 'react-router-dom';

const SUPPORT_CARDS = [
  {
    title: "Clinical Data Abstraction and Curation Solutions",
    desc: "Support of real-world evidence and real-world data efforts , review of protocol-specific inclusion/ exclusion eligibility criteria for trials"
  },
  {
    title: "Patient Engagement and Support Solutions",
    desc: "Patient concierge & patient contact center, patient engagement (recruitment, consent, adherence, retention, feedback), eConsent/ePRO/eCOA, patient monitoring"
  },
  {
    title: "Patient Engagement and Support Solutions",
    desc: "Ensuring provider credentialing and panel card creation for full compliance across all states, both mandatory and non-mandatory."
  },
  {
    title: "Remote Monitoring Solutions",
    desc: "Site qualification, site visits (initiation, interim, and closeout), site management activities, post-marketing/real-world evidence"
  }
];

const LifeSciences = () => {
  return (
    <div className="life-sciences-page">
      <div className="life-sciences-hero">
        <div className="life-sciences-hero-img" style={{ '--hero-bg': `url(${lifeSciencesHero})`, '--hero-bg-mob': `url(${lifeSciencesHeroMob})`, backgroundImage: `url(${lifeSciencesHero})` } as React.CSSProperties}>
          <div className="life-sciences-hero-content">
            <div className="life-sciences-hero-subtitle">Life Sciences</div>
            <div className="life-sciences-hero-title">Delivering Skilled Clinical Talent <br />for Life Sciences</div>
            <div className="life-sciences-hero-desc">Medwell360 offers a robust pipeline of highly trained, quality-driven professionals to support a wide range of life sciences roles. With a proven track record in performance and talent availability, we're the strategic partner you can rely on.</div>
          </div>
        </div>
      </div>

      <div className="life-science-facts">
        <Box className="life-science-facts-container">
          <Box className="life-science-facts-left">
            <div className="life-science-facts-title">
              High-Quality Support Services <br />to Drive Accurate Clinical Operations
            </div>
            <div className="life-science-facts-desc">
              Medwell360 delivers top-tier clinical professionals to support your life sciences initiatives with precision and quality.
            </div>
            <Link to="/contact-us" className="life-science-facts-btn">Contact Us</Link>
          </Box>
          <Box className="life-science-facts-right">
            <div className="life-science-facts-card">
              <div className="life-science-facts-card-title">
                Clinical Data Abstraction and Curation Solutions
              </div>
              <div className="life-science-facts-card-desc">
                Support of real-world evidence and real-world data efforts , review of protocol-specific inclusion/ exclusion eligibility criteria for trials
              </div>
            </div>
            <div className="life-science-facts-card">
              <div className="life-science-facts-card-title">
                Patient Engagement and Support Solutions
              </div>
              <div className="life-science-facts-card-desc">
                Patient concierge & patient contact center, patient engagement (recruitment, consent, adherence, retention, feedback), eConsent/ePRO/eCOA, patient monitoring
              </div>
            </div>
            <div className="life-science-facts-card">
              <div className="life-science-facts-card-title">
                Patient Engagement and Support Solutions
              </div>
              <div className="life-science-facts-card-desc">
                Ensuring provider credentialing and panel card creation for full compliance across all states, both mandatory and non-mandatory.
              </div>
            </div>
            <div className="life-science-facts-card">
              <div className="life-science-facts-card-title">
                Remote Monitoring Solutions
              </div>
              <div className="life-science-facts-card-desc">
                Site qualification, site visits (initiation, interim, and closeout), site management activities, post-marketing/real-world evidence
              </div>
            </div>
          </Box>
        </Box>
      </div>

      {/* Divider Section */}
      <div className="life-sciences-divider">
        <picture>
          <source media="(max-width: 1100px)" srcSet={lifeSciencesDividerMob} />
          <img src={lifeSciencesDivider} alt="Life Sciences Divider" className="life-sciences-divider-img" />
        </picture>
        <div className="life-sciences-divider-overlay" />
        <div className="life-sciences-divider-text">
          Helping You Find and Keep the Right Talent in Life Sciences
        </div>
      </div>

      {/* Life Sciences Success Section */}
      <div className="life-sciences-success life-sciences-content">
        <div className="life-sciences-success-opening">
          <div className="life-sciences-success-title">
            Delivering Clinical Talent for Life Sciences Success
          </div>
          <div className="life-sciences-success-desc">
            Medwell360 provides high-quality clinical professionals to support product development and commercialization across four critical domains. Our proven processes, deep clinical expertise, and unwavering commitment to quality ensure reliable execution. With Medwell360 as your partner, life sciences organizations can accelerate timelines and expand access to life-changing therapies for patients worldwide.
          </div>
        </div>
      </div>

      {/* Patient Engagement & Support Services Section */}
      <div className="life-sciences-success-patient life-sciences-content">
        <div className="life-sciences-success-patient-text">
          <div className="life-sciences-success-patient-title">
            Patient Engagement & Support Services
          </div>
          <div className="life-sciences-success-patient-desc">
            <p>Trust Medwell360 to enhance the quality and efficiency of your patient engagement strategy—accelerating study timelines, easing site burden, and improving experiences across the entire patient journey.</p>
            <p>Our skilled professionals support remote operations in:</p>
          </div>
          <ul className="life-sciences-success-patient-list">
            <li><b>Patient Concierge Services & Contact Center Support</b></li>
            <li><b>Patient Engagement: Recruitment, eConsent, adherence, retention, and feedback</b></li>
            <li><b>Digital Patient Tools: eConsent, ePRO, and eCOA platforms</b></li>
            <li><b>Patient Monitoring & Real-World Evidence:</b>
              <ul>
                <li className="life-sciences-success-patient-list-sub">Post-marketing surveillance</li>
                <li className="life-sciences-success-patient-list-sub">Mobile/digital health solutions</li>
                <li className="life-sciences-success-patient-list-sub">Remote monitoring & telemedicine</li>
              </ul>
            </li>
            <li><b>Care Coordination & Management</b></li>
          </ul>
        </div>
        <div className="life-sciences-success-patient-img">
          <picture>
            <source media="(max-width: 1100px)" srcSet={patientEngagementImgMob} />
            <img src={lifeScience1} alt="Patient Engagement" />
          </picture>
        </div>
      </div>

      {/* Clinical Talent Description Section */}
      <div className="clinical-talent-description life-sciences-content">
        {/* Remote Monitoring Section */}
        <div className="remote-monitoring">
          <div className="remote-monitoring-img">
            <picture>
              <source media="(max-width: 1100px)" srcSet={decentralizedTrialsImgMob} />
              <img src={lifeScience2} alt="Remote Monitoring" />
            </picture>
          </div>
          <div className="remote-monitoring-content">
            <div className="remote-monitoring-title">
              Remote Monitoring Solutions for Decentralized Clinical Trials
            </div>
            <div className="remote-monitoring-desc">
              Medwell360 provides dependable remote monitoring services to support the evolving needs of Decentralized Clinical Trials (DCTs). Our optimized delivery model helps you overcome the ongoing shortage of clinical talent—reducing cost and accelerating timelines without compromising quality. We advance your clinical development efforts while ensuring full compliance with ICH-GCP guidelines, regulatory standards, and study protocols.<br />
              Our clinical professionals support a range of remote activities, including:<br />
              Our skilled professionals support remote operations in:
            </div>
            <ul className="remote-monitoring-list">
              <li><b>Site Qualification and Management</b></li>
              <li><b>Site Monitoring Visits: Initiation, interim, and closeout</b></li>
              <li><b>Ongoing Site Management Activities</b></li>
              <li><b>Remote Source Data Verification (rSDV)</b></li>
              <li><b>Query Management and Resolution</b></li>
              <li><b>Post-Marketing Surveillance & Real-World Evidence Collection</b></li>
            </ul>
          </div>
        </div>

        {/* Pharmacovigilance Section */}
        <div className="pharmacovigilance-section">
          <div className="pharmacovigilance-text">
            <div className="pharmacovigilance-title">
              Pharmacovigilance & Safety Support Services
            </div>
            <div className="pharmacovigilance-desc">
              Medwell360 helps you meet global safety and regulatory obligations with confidence. Our experts deliver clinically informed safety reviews and efficient case processing through cost-effective, high-quality operations. With our support, you can streamline pharmacovigilance activities while enhancing both compliance and outcomes.<br />
              <p>We offer specialized talent to support:</p>
            </div>
            <ul className="pharmacovigilance-list">
              <li><b>Safety Case Management and Regulatory Reporting</b></li>
              <li><b>Patient Contact Center Services for Safety Follow-Up and Inquiries</b></li>
            </ul>
          </div>
          <div className="pharmacovigilance-img">
            <picture>
              <source media="(max-width: 1100px)" srcSet={pharmacovigilanceImgMob} />
              <img src={lifeScience3} alt="Pharmacovigilance" />
            </picture>
          </div>
        </div>

        {/* Clinical Data Abstraction Section */}
        <div className="clinical-data-abstraction">
          <div className="clinical-data-abstraction-img">
            <picture>
              <source media="(max-width: 1100px)" srcSet={clinicalDataAbstractionImgMob} />
              <img src={clinicalDataAbstractionImg} alt="Clinical Data Abstraction" />
            </picture>
          </div>
          <div className="clinical-data-abstraction-content">
            <div className="clinical-data-abstraction-title">
              Clinical Data Abstraction & Curation Services
            </div>
            <div className="clinical-data-abstraction-desc">
              As precision medicine and data-driven healthcare landscape evolves, Medwell360 offers the expertise to transform unstructured clinical and molecular data into meaningful, actionable insights. Our experienced professionals specialize in analyzing complex datasets at scale—powering evidence generation and informed decision-making.<br />
              Our teams support a wide range of data abstraction and curation activities, including:
            </div>
            <ul className="clinical-data-abstraction-list">
              <li><b>Real-World Data (RWD) & Real-World Evidence (RWE) support</b> through data extraction, structuring, and contextualization</li>
              <li><b>Clinical Note Review & Organization</b> for improved case clarity</li>
              <li><b>Lab Report & Pathology Image Interpretation</b></li>
              <li><b>Radiology Scan Review</b> to extract phenotypic, therapeutic, and outcomes data</li>
              <li><b>Eligibility Assessment</b> through protocol-specific inclusion/exclusion review for clinical trials</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Life Science Metrics Section */}
      <div className="life-science-metrics">
        <div className="life-science-metrics-heading">
          Quality Isn't Just a Metric—It's a Mission. <b>Medwell360 Delivers Nothing Less.</b>
        </div>
        <div className="life-science-metrics-row">
          <div className="life-science-metric">
            <div className="life-science-metric-value">99%</div>
            <div className="life-science-metric-label">Client Quality Rating</div>
          </div>
          <div className="life-science-metric">
            <div className="life-science-metric-value">3+</div>
            <div className="life-science-metric-label">Average Years of<br />Clinical Experience</div>
          </div>
          <div className="life-science-metric">
            <div className="life-science-metric-value">100%</div>
            <div className="life-science-metric-label">Client Satisfaction and<br />Challenge Resolution</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LifeSciences; 